import { createReducer, on } from "@ngrx/store";
import { obterEdicaoPorData, obterEdicaoPorDataSuccess, obterEdicaoPorDataFailure, obterEdicaoPorDataFinish } from "../../actions/Jornal/obter-edicao-por-data-publicacao.action";
import { EdicaoOutputDto } from "src/app/domain/DTOs/output/jornal/edicao-output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

export interface ObterEdicaoPorDataState {
    response: EstruturaRetornoDadosOutputDto<EdicaoOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterEdicaoPorDataState = {
    response: null,
    error: null,
};

export const ObterEdicaoPorDataReducer = createReducer(
    initialState,
    on(obterEdicaoPorData, state => ({ ...state, error: null })),
    on(obterEdicaoPorDataSuccess, (state, { response }) => ({ ...state, response, error: response.erros })),
    on(obterEdicaoPorDataFailure, (state, { response }) => ({ ...state, response, error: response.erros })),
    on(obterEdicaoPorDataFinish, state => ({ ...state, response: null, error: null }))
);
